// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveLearningLessonPage_wrapper__3Sy1e"};